import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SalesReportGraphWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background: ${Color.White};
  overflow: hidden;
`

interface ColorBoxProps {
  color: Color
  withBorder?: boolean
}

export const ColorBox = styled.div<ColorBoxProps>`
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  ${({ withBorder }) => withBorder && `border: 1px solid ${Color.Grey300};`}
  background: ${({ color }) => color};
`
